import React from 'react';
import PropTypes from 'prop-types';
import { faArrowAltCircleUp } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function ArrowUpButton({ content, onClick, disabled }) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faArrowAltCircleUp}
    />
  );
}

ArrowUpButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

ArrowUpButton.defaultProps = {
  onClick: () => null,
  content: 'Вгору',
  disabled: false,
};

export default ArrowUpButton;
